import React, { useCallback, useEffect, useState } from 'react';
import { Button, Grid, Typography, TextField, Box, Hidden, IconButton
    , FormControl, InputLabel, Select } from "@mui/material";
import { Search as IconSearch, IndeterminateCheckBox as IconIndeterminateCheckBox
    , CheckBox as IconCheckBox, AddCircle as IconAddCircle } from "@mui/icons-material";
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { Link, useNavigate } from 'react-router-dom';

import * as catalogoService from "../../services/catalogoService";
import trabajadorService from "../../services/trabajadorService";
import { setValue, setResults, setListCargo, setListEstado } from '../../redux/trabajadorSearchSlice';
import DialogYesNo from "../../components/DialogYesNo";
import DataGridBase from "../../components/common/DataGridBase"
import { useMantenimiento } from "../../hooks/useMantenimiento";

// Mantenimiento del personal: terapeutas, secretarias, personal de limpieza,
// director, coordinador, etc.
const CATALOGO_TIPOS_CARGO = 236;

const Index = () => {
    const { isReadOnly } = useMantenimiento("trabajador");
    const filters = useSelector((state) => state.trabajadorSearch.filters);
    const listCargo = useSelector((state) => state.trabajadorSearch.listCargo);
    const listEstado = useSelector((state) => state.trabajadorSearch.listEstado);

    const [openDialogAnnulActive, setOpenDialogAnnulActive] = useState(false)
    const openCloseDialogAnnulActive = () => { setOpenDialogAnnulActive(!openDialogAnnulActive); }
    const [selectId, setSelectId] = useState(null);
    const [selectState, setSelectState] = useState(null);

    const [cargando, setCargando] = useState(true);
    const [results, setResultsList] = useState([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const fetchResults = async () => {
        setCargando(true);

        const data = await trabajadorService.getsTrabajadorResumenView({
            nombres: filters.nombres == null ? "" : filters.nombres,
            idCargo: filters.idCargo == null ? 0 : filters.idCargo,
            idEstado: filters.idEstado == null ? 0 : filters.idEstado,
        })
            .catch((err) => { console.log("Err: ", err) });

        // La vista devuelve el id del trabajador en "id": se normaliza para el grid
        // y para los enlaces.
        setResultsList((data || []).map((row) => ({ ...row, idTrabajador: row.id, id: row.id })));
        dispatch(setResults(data || []));
        setCargando(false);
    }
    const fetchListCargo = async () => {
        const data = await catalogoService.getCatalogosByPadre(CATALOGO_TIPOS_CARGO)
            .catch((err) => { console.log("Err: ", err) });

        dispatch(setListCargo(data || []));
    }
    const fetchListEstado = async () => {
        const data = await catalogoService.getCatalogosByPadre(1)
            .catch((err) => { console.log("Err: ", err) });

        dispatch(setListEstado(data || []));
    }

    const annulTrabajador = async () => {
        await trabajadorService.annullTrabajador(selectId)
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
            });
        fetchResults();
    }
    const activeTrabajador = async () => {
        await trabajadorService.activeTrabajador(selectId)
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
            });
        fetchResults();
    }

    useEffect(() => {
        fetchResults();
        fetchListCargo();
        fetchListEstado();
    }, [])

    const columns = [
        { field: 'nombres', headerName: 'Nombres', width: 280, sortable: false, headerAlign: 'center'
            , renderCell: (cellValues) => {
                return <Link to={'/trabajador/edit/' + cellValues.row.idTrabajador} style={{ color: 'inherit' }}>
                    {cellValues.row.nombres}
                </Link>;
            }
        },
        { field: 'tipoDocumento', headerName: 'Tipo Doc', width: 90, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'numeroDocumento', headerName: 'Num. Doc', width: 110, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'tipoPersona', headerName: 'Tipo Persona', width: 130, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'cargo', headerName: 'Cargo', width: 150, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'seudonimo', headerName: 'Seudonimo', width: 140, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'fechaIngreso', headerName: 'Ingreso', width: 110, type: 'date'
            , valueFormatter: (value) => value ? moment(value).format('D/MM/YYYY') : ''
            , sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'estado', headerName: 'Estado', width: 80, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'anular', headerName: '', width: 70, sortable: false, headerAlign: 'center', align: 'center'
            , renderCell: (cellValues) => {
                return <IconButton aria-label="anular" size='small' style={{ height: 10 }} align={"center"} disabled={isReadOnly} onClick={() => {
                    setSelectId(cellValues.row.idTrabajador);
                    setSelectState(cellValues.row.estado);
                    setOpenDialogAnnulActive(true);
                }}>
                    { cellValues.row.estado == "Anulado" ? <IconIndeterminateCheckBox /> : <IconCheckBox /> }
                </IconButton>;
            }
        },
    ];

    return (
        <div>
            <Grid container>
                <Grid item>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        Personal
                    </Typography>
                </Grid>
                <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                    <Grid item xs={12} sm={12}>
                        <Grid container item xs={12} sm={12} spacing={1} padding={0}>
                            <Grid item xs={8} sm={4}>
                                <TextField
                                    name="nombres"
                                    label="Nombres"
                                    value={filters.nombres}
                                    fullWidth
                                    onChange={(event) => dispatch(setValue({ name: "nombres", value: event.target.value }))}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-cargofiltro">Cargo</InputLabel>
                                    <Select
                                        native
                                        label="Cargo"
                                        value={filters.idCargo}
                                        onChange={(event) => dispatch(setValue({ name: "idCargo", value: parseInt(event.target.value) }))}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{ name: 'idCargo', id: 'input-cargofiltro' }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Todos)"}</option>
                                        {listCargo.map((row) => (
                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-estadofiltro">Estado</InputLabel>
                                    <Select
                                        native
                                        label="Estado"
                                        value={filters.idEstado}
                                        onChange={(event) => dispatch(setValue({ name: "idEstado", value: parseInt(event.target.value) }))}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{ name: 'idEstado', id: 'input-estadofiltro' }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Todos)"}</option>
                                        {listEstado.map((row) => (
                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={4} sm={2} display={"flex"} alignItems={"center"}>
                                <Button variant="outlined" fullWidth size="medium" onClick={() => { fetchResults() }}>
                                    {<Hidden smDown></Hidden>}
                                    <IconSearch />
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                            <DataGridBase
                                rows={results}
                                columns={columns}
                                loading={cargando}
                                toolbarButtons={[
                                    {
                                        text: "Nuevo",
                                        icon: <IconAddCircle />,
                                        onClick: () => navigate("/trabajador/edit/0")
                                    }
                                ]}
                            />
                        </Box>
                    </Grid>
                    <DialogYesNo open={openDialogAnnulActive} openClose={openCloseDialogAnnulActive}
                        setYes={selectState == "Anulado" ? activeTrabajador : annulTrabajador}
                        setNo={() => { return }}
                        titulo={(selectState == "Anulado" ? "Activar" : "Anular") + " Personal"}
                        texto={"Esta seguro de " + (selectState == "Anulado" ? "activar" : "anular") + " al personal?"} >
                    </DialogYesNo>
                </Grid>
            </Grid>
        </div>
    )
}
export default Index